<script lang="ts" setup>
import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";
import type { RandomHouseArticle } from "@/types/article-formats/random-house";

const props = defineProps<{
  article: RandomHouseArticle;
  isCollapsible: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <ArticleContent>
    <div class="article-content__header article-header" v-html="props.article.html"></div>

    <ArticleContentCollapser :is-collapsible="props.isCollapsible">
      <div
        class="article-content__body-container article-content__body-container--reading-lines d-flex flex-column flex-lg-row"
      >
        <div
          class="indentation-container flex-grow-1 flex-shrink-1"
          v-html="props.article.html"
        ></div>
      </div>
    </ArticleContentCollapser>
  </ArticleContent>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.article-content {
  &__header {
    align-items: baseline;
    white-space: pre-wrap;

    ::v-deep(.random-house-article-headline) {
      color: rgb(@theme-colors[@secondary][base]);
      font-size: 24px;
      font-weight: 500;
    }

    ::v-deep(.random-house-article-content) {
      display: none;
    }
  }

  &__body-container {
    ::v-deep(.random-house-article-headline) {
      display: none;
    }

    ::v-deep(.random-house-article-content) {
      .title-box {
        color: rgb(@theme-colors[@primary][base]);
        font-weight: 500;

        sup {
          font-weight: 400;
        }
      }

      .new-entry {
        margin-top: 50px;
      }

      .number {
        color: rgb(@theme-colors[@secondary][110]);
        font-weight: 500;
      }

      .phonetic {
        color: rgb(@theme-colors[@grey][base]);
      }

      .conditional {
        font-weight: 400;
      }

      .wordclass {
        color: rgb(@theme-colors[@secondary][base]);
        font-weight: 500;
      }

      .upper {
        color: rgb(@theme-colors[@secondary][base]);
        font-weight: 500;
        text-transform: uppercase;
      }

      .content-block-container {
        margin-bottom: 50px;
      }

      .bullet {
        margin-bottom: 50px;

        b {
          color: rgb(@theme-colors[@primary][base]);
        }
      }
    }
  }
}
</style>
